import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postIssueTournament = (params) => {
    return axios.post(`${backendHost}/api/admin/tournament/issue`, params);
};

export {
    postIssueTournament
}